/**
 * Catalog van primary products die in de offerte-flow geselecteerd kunnen worden.
 * Houd in sync met `LeadProductMutationService.ALLOWED_PRIMARY_SKUS` (Apex).
 *
 * Pricing wordt server-side berekend door PricingService.repriceLead — de UI
 * hoeft hier geen prijs te tonen op aanmaak-moment.
 */

export type OfferteProductMode = 'shape' | 'count';

export interface OffertePrimaryProduct {
  sku: string;
  label: string;
  hint?: string;
  mode: OfferteProductMode;
  hasPackages: boolean;
}

export const OFFERTE_PRIMARY_PRODUCTS: OffertePrimaryProduct[] = [
  {
    sku: 'WAS-PRIM-VLOERKLEED-REINIGEN',
    label: 'Vloerkleed',
    hint: 'Standaard vloerkledenreiniging — vorm + afmeting bepalen de prijs.',
    mode: 'shape',
    hasPackages: true,
  },
  {
    sku: 'WAS-PRIM-VLOERKLEED-WEDERVERKOPER',
    label: 'Vloerkleed Wederverkoper',
    hint: 'B2B-tarief voor wederverkopers — eigen pakketset.',
    mode: 'shape',
    hasPackages: true,
  },
  {
    sku: 'WAS-PRIM-VLOERKLEED-IMPREGNEREN',
    label: 'Vloerkleed Impregneren',
    hint: 'Losse impregneerbehandeling voor nieuwe vloerkleden — geen wasbeurt, geen pakket.',
    mode: 'shape',
    hasPackages: false,
  },
  {
    sku: 'WAS-PRIM-KUSSEN-REINIGEN',
    label: 'Kussen',
    hint: 'Per stuk afgerekend — geen vorm of afmeting nodig.',
    mode: 'count',
    hasPackages: false,
  },
];

export const DEFAULT_OFFERTE_PRIMARY_SKU = 'WAS-PRIM-VLOERKLEED-REINIGEN';

export function findOffertePrimaryProduct(sku: string | null | undefined): OffertePrimaryProduct {
  return (
    OFFERTE_PRIMARY_PRODUCTS.find((p) => p.sku === sku) ??
    OFFERTE_PRIMARY_PRODUCTS[0]!
  );
}

export function isCountBasedSku(sku: string | null | undefined): boolean {
  return findOffertePrimaryProduct(sku).mode === 'count';
}
